import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ResultNotFound',
  render() {
    return (
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 213 213"
        style={{
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          strokeLinejoin: 'round',
          strokeMiterlimit: 2,
        }}
      >
        <g transform="matrix(1,0,0,1,-1241.95,-445.62)">
          <g>
            <g transform="matrix(1,0,0,1,295.2,-87.3801)">
              <circle
                cx="1053.23"
                cy="639.477"
                r="106.477"
                style={{ fill: 'rgb(235, 238, 246)' }}
              />
            </g>
            <g transform="matrix(0.38223,0,0,0.38223,1126.12,238.549)">
              <g transform="matrix(0.566536,0.327089,-1.28774,0.74348,763.4,317.171)">
                <rect
                  x="657.012"
                  y="404.643"
                  width="198.586"
                  height="145.08"
                  style={{ fillOpacity: 0.1 }}
                />
              </g>
              <g transform="matrix(0.29595,0.170867,-0.91077,0.525833,873.797,588.624)">
                <rect
                  x="657.012"
                  y="404.643"
                  width="198.586"
                  height="145.08"
                  style={{ fillOpacity: 0.1 }}
                />
              </g>
              <g transform="matrix(1,0,0,1,275,-15)">
                <path
                  d="M262.077,959.012L276.923,959.012L273.388,1004.01C273.388,1004.59 273.009,1005.16 272.25,1005.6C270.732,1006.48 268.268,1006.48 266.75,1005.6C265.991,1005.16 265.612,1004.59 265.612,1004.01L262.077,959.012Z"
                  style={{ fill: 'rgb(196, 173, 142)' }}
                />
                <g transform="matrix(0.866025,-0.5,1,0.57735,0,-45)">
                  <ellipse
                    cx="-848.416"
                    cy="1004.25"
                    rx="6.062"
                    ry="5.25"
                    style={{ fill: 'rgb(255, 125, 0)' }}
                  />
                </g>
              </g>
              <g transform="matrix(1,0,0,1,183.952,-67.5665)">
                <path
                  d="M262.077,959.012L276.923,959.012L273.388,1004.01C273.388,1004.59 273.009,1005.16 272.25,1005.6C270.732,1006.48 268.268,1006.48 266.75,1005.6C265.991,1005.16 265.612,1004.59 265.612,1004.01L262.077,959.012Z"
                  style={{ fill: 'rgb(196, 173, 142)' }}
                />
                <g transform="matrix(0.866025,-0.5,1,0.57735,0,-45)">
                  <ellipse
                    cx="-848.416"
                    cy="1004.25"
                    rx="6.062"
                    ry="5.25"
                    style={{ fill: 'rgb(255, 125, 0)' }}
                  />
                </g>
              </g>
              <g transform="matrix(1,0,0,1,414,-95.2517)">
                <path
                  d="M262.077,959.012L276.923,959.012L273.388,1004.01C273.388,1004.59 273.009,1005.16 272.25,1005.6C270.732,1006.48 268.268,1006.48 266.75,1005.6C265.991,1005.16 265.612,1004.59 265.612,1004.01L262.077,959.012Z"
                  style={{ fill: 'rgb(196, 173, 142)' }}
                />
                <g transform="matrix(0.866025,-0.5,1,0.57735,0,-45)">
                  <ellipse
                    cx="-848.416"
                    cy="1004.25"
                    rx="6.062"
                    ry="5.25"
                    style={{ fill: 'rgb(255, 125, 0)' }}
                  />
                </g>
              </g>
              <g transform="matrix(1,0,0,1,322.952,-147.818)">
                <path
                  d="M262.077,959.012L276.923,959.012L273.388,1004.01C273.388,1004.59 273.009,1005.16 272.25,1005.6C270.732,1006.48 268.268,1006.48 266.75,1005.6C265.991,1005.16 265.612,1004.59 265.612,1004.01L262.077,959.012Z"
                  style={{ fill: 'rgb(196, 173, 142)' }}
                />
                <g transform="matrix(0.866025,-0.5,1,0.57735,0,-45)">
                  <ellipse
                    cx="-848.416"
                    cy="1004.25"
                    rx="6.062"
                    ry="5.25"
                    style={{ fill: 'rgb(255, 125, 0)' }}
                  />
                </g>
              </g>
              <g>
                <g transform="matrix(1.42334,-0.821763,1.11271,0.642426,-1439.64,459.621)">
                  <rect
                    x="495.52"
                    y="1057.87"
                    width="105.078"
                    height="91"
                    style={{ fill: 'rgb(253, 243, 228)' }}
                  />
                </g>
                <g transform="matrix(1.40786,-0.812831,6.60237e-16,1.99081,-2052.17,-84.7286)">
                  <rect
                    x="1844.06"
                    y="1192.54"
                    width="106.232"
                    height="92"
                    style={{ fill: 'rgb(196, 173, 142)' }}
                  />
                </g>
                <g transform="matrix(1.26159,-0.728382,5.91642e-16,1.78397,-1774.67,11.2303)">
                  <path
                    d="M1950.29,1194.38C1950.29,1193.37 1949.41,1192.54 1948.34,1192.54L1846.01,1192.54C1844.93,1192.54 1844.06,1193.37 1844.06,1194.38L1844.06,1282.7C1844.06,1283.72 1844.93,1284.54 1846.01,1284.54L1948.34,1284.54C1949.41,1284.54 1950.29,1283.72 1950.29,1282.7L1950.29,1194.38Z"
                    style={{ fill: 'rgb(132, 97, 51)' }}
                  />
                </g>
                <g transform="matrix(1.2198,-0.704254,5.72043e-16,1.72488,-1697.6,37.2103)">
                  <path
                    d="M1950.29,1194.38C1950.29,1193.37 1949.41,1192.54 1948.34,1192.54L1846.01,1192.54C1844.93,1192.54 1844.06,1193.37 1844.06,1194.38L1844.06,1282.7C1844.06,1283.72 1844.93,1284.54 1846.01,1284.54L1948.34,1284.54C1949.41,1284.54 1950.29,1283.72 1950.29,1282.7L1950.29,1194.38Z"
                    style={{ fill: 'rgb(196, 173, 142)' }}
                  />
                </g>
                <g transform="matrix(0.707187,0.408295,9.06119e-17,1.54833,-733.949,683.612)">
                  <rect
                    x="1663.92"
                    y="-407.511"
                    width="143.183"
                    height="118.292"
                    style={{ fill: 'rgb(240, 218, 183)' }}
                  />
                </g>
                <g transform="matrix(1.64553,-0.950049,1.17482,0.678285,-1632.45,473.879)">
                  <rect
                    x="495.52"
                    y="1057.87"
                    width="105.078"
                    height="91"
                    style={{ fill: 'rgb(253, 243, 228)' }}
                  />
                </g>
                <g transform="matrix(0.74666,0.431085,2.3583e-17,0.135259,-816.63,57.1397)">
                  <rect
                    x="1663.92"
                    y="-407.511"
                    width="143.183"
                    height="118.292"
                    style={{ fill: 'rgb(240, 218, 183)' }}
                  />
                </g>
                <g transform="matrix(1.64553,-0.950049,1.17482,0.678285,-1632.45,473.879)">
                  <rect
                    x="495.52"
                    y="1057.87"
                    width="105.078"
                    height="91"
                    style={{ fill: 'rgb(253, 243, 228)' }}
                  />
                </g>
                <g transform="matrix(0.750082,0,0,0.750082,163.491,354.191)">
                  <g transform="matrix(1.75943,-1.01581,1.75879e-16,0.632893,-2721.54,1876.43)">
                    <rect
                      x="1844.06"
                      y="1192.54"
                      width="106.232"
                      height="92"
                      style={{ fill: 'rgb(196, 173, 142)' }}
                    />
                  </g>
                  <g transform="matrix(0.290956,-0.167984,2.90849e-17,0.104661,69.4195,919.311)">
                    <path
                      d="M1950.29,1238.54C1950.29,1213.15 1944.73,1192.54 1937.88,1192.54L1856.47,1192.54C1849.62,1192.54 1844.06,1213.15 1844.06,1238.54C1844.06,1263.93 1849.62,1284.54 1856.47,1284.54L1937.88,1284.54C1944.73,1284.54 1950.29,1263.93 1950.29,1238.54Z"
                      style={{ fill: 'rgb(132, 97, 51)' }}
                    />
                  </g>
                  <g transform="matrix(0.262716,-0.151679,8.27418e-18,0.0364999,121.496,970.53)">
                    <path
                      d="M1950.29,1238.54C1950.29,1213.15 1948.14,1192.54 1945.5,1192.54L1848.85,1192.54C1846.2,1192.54 1844.06,1213.15 1844.06,1238.54C1844.06,1263.93 1846.2,1284.54 1848.85,1284.54L1945.5,1284.54C1948.14,1284.54 1950.29,1263.93 1950.29,1238.54Z"
                      style={{ fill: 'rgb(246, 220, 185)' }}
                    />
                  </g>
                  <g transform="matrix(1.77877,-1.02697,0.0581765,0.0335882,-425.293,1228.27)">
                    <rect
                      x="495.52"
                      y="1057.87"
                      width="105.078"
                      height="91"
                      style={{ fill: 'rgb(240, 218, 183)' }}
                    />
                  </g>
                  <g transform="matrix(0.0369741,0.021347,4.72735e-17,0.492225,456.143,919.985)">
                    <rect
                      x="1663.92"
                      y="-407.511"
                      width="143.183"
                      height="118.292"
                      style={{ fill: 'rgb(240, 218, 183)' }}
                    />
                  </g>
                </g>
                <g transform="matrix(0.750082,0,0,0.750082,163.491,309.191)">
                  <g transform="matrix(1.75943,-1.01581,1.75879e-16,0.632893,-2721.54,1876.43)">
                    <rect
                      x="1844.06"
                      y="1192.54"
                      width="106.232"
                      height="92"
                      style={{ fill: 'rgb(196, 173, 142)' }}
                    />
                  </g>
                  <g transform="matrix(0.290956,-0.167984,2.90849e-17,0.104661,69.4195,919.311)">
                    <path
                      d="M1950.29,1238.54C1950.29,1213.15 1944.73,1192.54 1937.88,1192.54L1856.47,1192.54C1849.62,1192.54 1844.06,1213.15 1844.06,1238.54C1844.06,1263.93 1849.62,1284.54 1856.47,1284.54L1937.88,1284.54C1944.73,1284.54 1950.29,1263.93 1950.29,1238.54Z"
                      style={{ fill: 'rgb(132, 97, 51)' }}
                    />
                  </g>
                  <g transform="matrix(0.262716,-0.151679,8.27418e-18,0.0364999,121.496,970.53)">
                    <path
                      d="M1950.29,1238.54C1950.29,1213.15 1948.14,1192.54 1945.5,1192.54L1848.85,1192.54C1846.2,1192.54 1844.06,1213.15 1844.06,1238.54C1844.06,1263.93 1846.2,1284.54 1848.85,1284.54L1945.5,1284.54C1948.14,1284.54 1950.29,1263.93 1950.29,1238.54Z"
                      style={{ fill: 'rgb(246, 220, 185)' }}
                    />
                  </g>
                  <g transform="matrix(1.77877,-1.02697,0.0581765,0.0335882,-425.293,1228.27)">
                    <rect
                      x="495.52"
                      y="1057.87"
                      width="105.078"
                      height="91"
                      style={{ fill: 'rgb(240, 218, 183)' }}
                    />
                  </g>
                  <g transform="matrix(0.0369741,0.021347,4.72735e-17,0.492225,456.143,919.985)">
                    <rect
                      x="1663.92"
                      y="-407.511"
                      width="143.183"
                      height="118.292"
                      style={{ fill: 'rgb(240, 218, 183)' }}
                    />
                  </g>
                </g>
                <g transform="matrix(0.750082,0,0,0.750082,163.491,263.931)">
                  <g transform="matrix(1.75943,-1.01581,1.75879e-16,0.632893,-2721.54,1876.43)">
                    <rect
                      x="1844.06"
                      y="1192.54"
                      width="106.232"
                      height="92"
                      style={{ fill: 'rgb(196, 173, 142)' }}
                    />
                  </g>
                  <g transform="matrix(0.290956,-0.167984,2.90849e-17,0.104661,69.4195,919.311)">
                    <path
                      d="M1950.29,1238.54C1950.29,1213.15 1944.73,1192.54 1937.88,1192.54L1856.47,1192.54C1849.62,1192.54 1844.06,1213.15 1844.06,1238.54C1844.06,1263.93 1849.62,1284.54 1856.47,1284.54L1937.88,1284.54C1944.73,1284.54 1950.29,1263.93 1950.29,1238.54Z"
                      style={{ fill: 'rgb(132, 97, 51)' }}
                    />
                  </g>
                  <g transform="matrix(0.262716,-0.151679,8.27418e-18,0.0364999,121.496,970.53)">
                    <path
                      d="M1950.29,1238.54C1950.29,1213.15 1948.14,1192.54 1945.5,1192.54L1848.85,1192.54C1846.2,1192.54 1844.06,1213.15 1844.06,1238.54C1844.06,1263.93 1846.2,1284.54 1848.85,1284.54L1945.5,1284.54C1948.14,1284.54 1950.29,1263.93 1950.29,1238.54Z"
                      style={{ fill: 'rgb(246, 220, 185)' }}
                    />
                  </g>
                  <g transform="matrix(1.77877,-1.02697,0.0581765,0.0335882,-425.293,1228.27)">
                    <rect
                      x="495.52"
                      y="1057.87"
                      width="105.078"
                      height="91"
                      style={{ fill: 'rgb(240, 218, 183)' }}
                    />
                  </g>
                  <g transform="matrix(0.0369741,0.021347,4.72735e-17,0.492225,456.143,919.985)">
                    <rect
                      x="1663.92"
                      y="-407.511"
                      width="143.183"
                      height="118.292"
                      style={{ fill: 'rgb(240, 218, 183)' }}
                    />
                  </g>
                </g>
                <path
                  d="M555.753,832.474L555.753,921.408L630.693,878.141L630.693,789.207L555.753,832.474Z"
                  style={{ fillOpacity: 0.1 }}
                />
                <g transform="matrix(0.750082,0,0,0.750082,236.431,272.852)">
                  <g transform="matrix(1.64553,-0.950049,1.14552,0.661368,-1606.78,467.933)">
                    <rect
                      x="495.52"
                      y="1057.87"
                      width="105.078"
                      height="91"
                      style={{ fill: 'rgb(253, 243, 228)' }}
                    />
                  </g>
                  <g transform="matrix(1.54477,-0.891873,1.05847,0.611108,-1456.84,490.734)">
                    <rect
                      x="495.52"
                      y="1057.87"
                      width="105.078"
                      height="91"
                      style={{ fill: 'rgb(132, 97, 51)' }}
                    />
                  </g>
                  <g transform="matrix(1.27607,-0.736739,0.751435,0.433841,-970.952,617.519)">
                    <rect
                      x="495.52"
                      y="1057.87"
                      width="105.078"
                      height="91"
                      style={{ fill: 'rgb(240, 218, 183)' }}
                    />
                  </g>
                  <g transform="matrix(1.62765,-0.939723,1.42156e-16,0.5,-2476.81,1893.62)">
                    <rect
                      x="1844.06"
                      y="1192.54"
                      width="106.232"
                      height="92"
                      style={{ fill: 'rgb(196, 173, 142)' }}
                    />
                  </g>
                  <g transform="matrix(1.62765,-0.939723,1.42156e-16,0.5,-2476.81,1893.62)">
                    <rect
                      x="1844.06"
                      y="1192.54"
                      width="106.232"
                      height="92"
                      style={{ fill: 'rgb(196, 173, 142)' }}
                    />
                  </g>
                  <g transform="matrix(0.728038,0.420333,3.52595e-17,0.377589,-790.978,151.274)">
                    <rect
                      x="1663.92"
                      y="-407.511"
                      width="143.183"
                      height="118.292"
                      style={{ fill: 'rgb(240, 218, 183)' }}
                    />
                  </g>
                  <g transform="matrix(1.75943,-1.01581,1.75879e-16,0.632893,-2726.83,1873.38)">
                    <rect
                      x="1844.06"
                      y="1192.54"
                      width="106.232"
                      height="92"
                      style={{ fill: 'rgb(196, 173, 142)' }}
                    />
                  </g>
                  <g>
                    <g transform="matrix(1.75943,-1.01581,1.75879e-16,0.632893,-2721.54,1876.43)">
                      <rect
                        x="1844.06"
                        y="1192.54"
                        width="106.232"
                        height="92"
                        style={{ fill: 'rgb(196, 173, 142)' }}
                      />
                    </g>
                    <g transform="matrix(0.290956,-0.167984,2.90849e-17,0.104661,69.4195,919.311)">
                      <path
                        d="M1950.29,1238.54C1950.29,1213.15 1944.73,1192.54 1937.88,1192.54L1856.47,1192.54C1849.62,1192.54 1844.06,1213.15 1844.06,1238.54C1844.06,1263.93 1849.62,1284.54 1856.47,1284.54L1937.88,1284.54C1944.73,1284.54 1950.29,1263.93 1950.29,1238.54Z"
                        style={{ fill: 'rgb(132, 97, 51)' }}
                      />
                    </g>
                    <g transform="matrix(0.262716,-0.151679,8.27418e-18,0.0364999,121.496,970.53)">
                      <path
                        d="M1950.29,1238.54C1950.29,1213.15 1948.14,1192.54 1945.5,1192.54L1848.85,1192.54C1846.2,1192.54 1844.06,1213.15 1844.06,1238.54C1844.06,1263.93 1846.2,1284.54 1848.85,1284.54L1945.5,1284.54C1948.14,1284.54 1950.29,1263.93 1950.29,1238.54Z"
                        style={{ fill: 'rgb(246, 220, 185)' }}
                      />
                    </g>
                    <g transform="matrix(1.77877,-1.02697,0.0581765,0.0335882,-425.293,1228.27)">
                      <rect
                        x="495.52"
                        y="1057.87"
                        width="105.078"
                        height="91"
                        style={{ fill: 'rgb(240, 218, 183)' }}
                      />
                    </g>
                    <g transform="matrix(0.0369741,0.021347,4.72735e-17,0.492225,456.143,919.985)">
                      <rect
                        x="1663.92"
                        y="-407.511"
                        width="143.183"
                        height="118.292"
                        style={{ fill: 'rgb(240, 218, 183)' }}
                      />
                    </g>
                  </g>
                </g>
                <g transform="matrix(1.62765,-0.939723,4.80984e-17,0.173913,-2468.81,2307.87)">
                  <rect
                    x="1844.06"
                    y="1192.54"
                    width="106.232"
                    height="92"
                    style={{ fill: 'rgb(196, 173, 142)' }}
                  />
                </g>
              </g>
              <g>
                <g transform="matrix(0.479077,0.276595,-0.564376,0.325843,598.357,-129.986)">
                  <path
                    d="M1776.14,1326C1776.14,1321.19 1772.15,1317.28 1767.24,1317.28L1684.37,1317.28C1679.46,1317.28 1675.47,1321.19 1675.47,1326L1675.47,1395.75C1675.47,1400.56 1679.46,1404.46 1684.37,1404.46L1767.24,1404.46C1772.15,1404.46 1776.14,1400.56 1776.14,1395.75L1776.14,1326Z"
                    style={{ fill: 'white' }}
                  />
                </g>
                <g transform="matrix(2.61622,0,0,2.61622,-2305.73,162.161)">
                  <g transform="matrix(1.09915,-0.634597,1.26919,0.73277,-299.167,-62.4615)">
                    <ellipse
                      cx="412.719"
                      cy="770.575"
                      rx="6.303"
                      ry="5.459"
                      style={{ fill: 'rgb(255, 125, 0)' }}
                    />
                  </g>
                  <g transform="matrix(0.238212,-0.137532,0.178659,0.103149,875.064,207.93)">
                    <text
                      x="413.474px"
                      y="892.067px"
                      style={{
                        fontFamily: 'NunitoSans-Bold, Nunito Sans',
                        fontWeight: 700,
                        fontSize: 41.569,
                        fill: 'white',
                      }}
                    >
                      ?
                    </text>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    );
  },
});
